import React from "react";
import { Outlet } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { switchLanguage } from "@envirohub/i18n";
import { AuthLayout } from "@envirohub/ui";

export default function PublicLayout() {
  const { t, i18n } = useTranslation();

  const handleLanguageToggle = () => {
    switchLanguage(i18n.language === "en" ? "ar" : "en");
  };

  return (
    <AuthLayout
      title="EnviroHub"
      subtitle={t("auth.customerSubtitle", { defaultValue: "Urban Services Platform" })}
      primaryGradientClassName="bg-primary/20"
      secondaryGradientClassName="bg-secondary/20"
      iconContainerClassName="bg-primary shadow-primary/30 text-white"
      currentLanguage={i18n.language}
      onLanguageToggle={handleLanguageToggle}
      icon={
        <svg className="w-8 h-8 text-white" fill="none" viewBox="0 0 24 24" stroke="currentColor">
          <path
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth={2}
            d="M5 3v4M3 5h4M6 17v4m-2-2h4m5-16l2.286 6.857L21 12l-5.714 2.143L13 21l-2.286-6.857L5 12l5.714-2.143L13 3z"
          />
        </svg>
      }
    >
      <Outlet />
    </AuthLayout>
  );
}
